import { Button, IconButton, Stack, styled, Typography } from '@mui/material';

// SettingBox / LeftSide / Subtitle / WhiteWrapper are the legacy two-column
// layout (label column beside a card). Don't use them on new pages; move a
// page onto PageHeader/PageSection (@/components/Layout/PageLayout) when a PR
// is already reworking that page's UI — CONTRACT #13.
export const SettingBox = styled(Stack)`
  flex-direction: row;
  padding: 1.5rem 0;
  gap: 32px;
  justify-content: flex-start;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const WhiteWrapper = styled(Stack)`
  background-color: white;
  padding: 1.5rem;
  border-radius: 1.5rem;
  border: 1px solid ${({ theme }) => theme.palette.neutral.otherBorder};
  flex: 1;
  /* allow this column to grow beyond its original max-width */
  max-width: none;

  @media (max-width: 900px) {
    padding: 1rem;
  }
`;

export const LeftSide = styled(Stack)`
  gap: 8px;
  max-width: 200px;
  width: 20%;

  @media (max-width: 900px) {
    width: 100%;
    max-width: none;
  }
`;

export const Subtitle = styled(Typography)`
  max-width: 180px;
  color: ${({ theme }) => theme.palette.neutral.greyFont};

  @media (max-width: 900px) {
    max-width: none;
  }
`;

export const UploadFileBox = styled(Stack, { shouldForwardProp: (prop) => prop !== 'isDragActive' })<{
  isDragActive: boolean;
}>`
  align-items: center;
  padding: 1.5rem;
  border-radius: 1.5rem;
  border: 1px dashed ${({ theme }) => theme.palette.neutral.dashBorder};
  flex: 1;
  cursor: pointer;
  ${({ isDragActive, theme }) => isDragActive && `background: ${theme.palette.neutral.lightBackground};`}

  svg {
    margin: 12px;
  }
`;

export const TextWithSpan = styled(Typography)`
  color: ${({ theme }) => theme.palette.neutral.greyFont};
  margin-bottom: 0.5rem;

  span {
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 700;
  }
`;

export const StyledIconButton = styled(IconButton)`
  background-color: ${({ theme }) => theme.palette.neutral.lightBackground};
  margin-bottom: 1.5rem;
`;

export const DeleteButton = styled(Button)`
  font-weight: 700;
  width: fit-content;
`;

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const StyledForm = styled('form')`
  width: 100%;
  height: 100%;
  max-width: 650px;
`;
